// src/components/Footer.jsx
import React from "react";
import { Layout, Typography, Space } from "antd";
import { GithubOutlined, QqOutlined, WechatOutlined } from "@ant-design/icons";
import "./Footer.css";

const { Footer: AntFooter } = Layout;
const { Text, Link } = Typography;

const Footer = () => {
  return (
    <AntFooter className="app-footer">
      <Text>© {new Date().getFullYear()} 我的博客. All Rights Reserved.</Text>
      <Space size="large" className="social-links">
        <Link
          href="https://github.com/chenlei-coder"
          target="_blank"
          title="GitHub"
        >
          <GithubOutlined
            style={{ fontSize: "24px", color: "rgba(0, 0, 0, 0.65)" }}
          />
        </Link>
        <Link href="https://im.qq.com" target="_blank" title="QQ">
          <QqOutlined
            style={{ fontSize: "24px", color: "rgba(0, 0, 0, 0.65)" }}
          />
        </Link>
        <Link href="https://weixin.qq.com" target="_blank" title="微信">
          <WechatOutlined
            style={{ fontSize: "24px", color: "rgba(0, 0, 0, 0.65)" }}
          />
        </Link>
      </Space>
      <Text>Proudly powered by React & Ant Design</Text>
    </AntFooter>
  );
};

export default Footer;
